// The /state entry exposes the filter scope without any UI imports.

import { getFilterScope } from '@statsbomb/kitbag-global-football/state';
import { atom } from 'jotai';
import { COMPETITION_AVERAGE_SCOPE } from '@/consts/comparison';
import { filterAtomDefaults } from '@/consts/defaults/filterAtomDefaults';
import { ConfigFilterAtomValues } from '@/types/userConfigs';

export const competitionAverageScope = getFilterScope(COMPETITION_AVERAGE_SCOPE);

const scopeSnapshotAtom = atom(competitionAverageScope.get());
scopeSnapshotAtom.onMount = setSnapshot => {
  setSnapshot(competitionAverageScope.get());
  return competitionAverageScope.subscribe(setSnapshot);
};

export const competitionAverageFiltersAtom = atom(
  get => get(scopeSnapshotAtom),
  (_get, set, next: ConfigFilterAtomValues) => {
    competitionAverageScope.set(next);
    // Write through to the local snapshot so a read in the same store is
    // correct even before (or without) the mount-time subscription.
    set(scopeSnapshotAtom, competitionAverageScope.get());
  },
);

export const resetCompetitionAverageFiltersAtom = atom(null, (_, set) => {
  set(competitionAverageFiltersAtom, { ...filterAtomDefaults });
});
